/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DeviceType from './device-type';
import DeviceTypeDetail from './device-type-detail';
import DeviceTypeUpdate from './device-type-update';
import DeviceTypeDeleteDialog from './device-type-delete-dialog';

const DeviceTypeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DeviceType />} />
    <Route path="new" element={<DeviceTypeUpdate />} />
    <Route path=":id">
      <Route index element={<DeviceTypeDetail />} />
      <Route path="edit" element={<DeviceTypeUpdate />} />
      <Route path="delete" element={<DeviceTypeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DeviceTypeRoutes;
